import { Component, OnDestroy, OnInit } from '@angular/core';
import { PlayerService } from "../../character/player.service";
import { Subject } from 'rxjs';
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-health-bar',
    templateUrl: './health-bar.component.html',
    styleUrls: ['./health-bar.component.css']
})
export class HealthBarComponent implements OnInit, OnDestroy {
    public health: number | undefined;
    private destroy$ = new Subject<void>();

    constructor(private playerService: PlayerService) {
    }

    ngOnInit(): void {
        this.playerService.health$
            .pipe(takeUntil(this.destroy$))
            .subscribe((health) => {
                this.health = health.health;
                this.updateHealthBar(health.damage);
            });
    }

    private updateHealthBar(damage: number): void {
        // Update Player's  health bar
        const healthBarElement = document.getElementById('health-bar');
        const barElement = document.getElementById('bar');
        const hitElement = document.getElementById('hit');

        const healthMaxValue = parseInt(healthBarElement.dataset.total) as number;
        const healthValue = parseInt(healthBarElement.dataset.value) as number;

        const newValue = (healthValue - damage) as number;

        const barWidth = (newValue / healthMaxValue) * 100;
        const hitWidth = (damage / healthValue) * 100 + '%';

        hitElement.style.width = hitWidth;
        healthBarElement.dataset.value = String(newValue);

        setTimeout(() => {
            hitElement.style.width = '0';
            barElement.style.width = barWidth + '%';
        }, 500);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
